import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppUrls } from 'src/app/helpers/app-urls';

@Injectable({
  providedIn: 'root'
})
export class CalendarTypeService {

  apiUrl: string;

  constructor(private httpclient: HttpClient) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
  }

  getCalendarTypes(page: number, size: number, orgid: number, typeid: number, type: string) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
    const url = this.apiUrl + '/api/calendartype/' + page + '/' + size + '/' + orgid + '/' + typeid + '/' + type + '/';
    return this.httpclient.get<any>(url);
  }

}
